export default __webpack_public_path__ + "static/media/info-input-icon.00a72add.svg";